<template>
  <div class="allBox">
    <div>
      <!-- :rules="[{ required: true, message: '请上传' }]" -->
      <van-field :name="code">
        <template #input>
          <van-uploader
            v-model="uploader"
            :max-count="1"
            accept="image/*"
            :before-read="beforeRead"
            :afterRead="afterRead"
            capture
            @delete="remove"
            @click-upload="clickUpload"
          />
        </template>
      </van-field>
    </div>
  </div>
</template>
<script>
import { imageUpload, getIdentificationPa, addHardwareLog } from '@/api/api.js'
import { Toast, Dialog } from 'vant'
import Exif from 'exif-js'
import UA from 'ua-device'
export default {
  props: {
    item: {
      type: Object,
      default: {}
    },
    code: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: -1
    },
    nofatch: {
      type: Boolean,
      default: false
    },
    isHD: {
      type: Boolean,
      default: false
    },
    tenCode: {
      type: String,
      default: ''
    },
    tips: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      uploader: [], // 上传的文件数组
      files: {
        name: '',
        type: ''
      }, // 图片信息 用于压缩图片
      current: 0
    }
  },
  methods: {
    clickUpload() {
      this.$emit('clickImgsUpload')
    },
    // 上传前
    beforeRead(file) {
      return new Promise((resolve) => {
        this.$store.commit('changeloadingStatus', true)

        // 1. 基础验证
        if (!file.type.startsWith('image/')) {
          Toast('请拍照上传')
          this.$store.commit('changeloadingStatus', false)
          reject()
          return
        }

        this.getPhotoDateTime(file).then(photoTime => {
          // 验证拍摄时间是否在合理范围内（例如最近24小时内）
          const now = new Date()
          const minutesDiff = (now - photoTime) / (1000 * 60)
          // 图片要十分钟之内上传
          if (minutesDiff > 10) {
            this.getUserAgent('图片上传获取时间超时:photoTime=' + photoTime + ',now=' + now);
            // Toast('请重新拍摄照片');
            // this.$store.commit('changeloadingStatus', false)
            // reject()
            // return
          }
          // 2. 获取设备信息
          const ua = new UA(navigator.userAgent)
          const deviceInfo = {
            deviceType: ua.device.type,
          }

          // file.status = "uploading";
          // file.message = "上传中...";
          this.files.name = file.name // 获取文件名
          this.files.type = file.type // 获取类型
          this.imgPreview(file).then((base64) => {
            resolve(this.dataURLtoFile(base64))
          })

        }).catch(error => {
          // 处理没有时间信息的情况
          // file.status = "uploading";
          // file.message = "上传中...";
          this.files.name = file.name // 获取文件名
          this.files.type = file.type // 获取类型
          this.getUserAgent('图片上传获取时间异常:' + error.message + ',fileName=' + this.files.name + ',fileType=' + this.files.type);
          this.imgPreview(file).then((base64) => {
            resolve(this.dataURLtoFile(base64))
          })
        });
        
      })
    },
    afterRead(file) {
      // 读取后file.content=undefined可以避免先渲染本地图片的问题
      if (this.nofatch !== true) {
        file.content = undefined
      }
      if (this.nofatch === true) {
        const newObj = JSON.parse(JSON.stringify(this.item))
        this.$emit('update:item', {
          ...newObj,
          absoluteUrl: file.content,
          relativeUrl: '/nofatch'
        })
        this.$emit('done', this.index)
      }
      // file.status = 'uploading'
      // file.message = '上传中...'
    },
    // 处理图片
    imgPreview(file) {
      // console.log('file111: ', file.size / 1024)
      return new Promise((resolve) => {
        const self = this
        let Orientation
        // 去获取拍照时的信息，解决拍出来的照片旋转问题   npm install exif-js --save
        Exif.getData(file, function () {
          Orientation = Exif.getTag(this, 'Orientation')
        })
        // 看支持不支持FileReader
        if (!file || !window.FileReader) return
        if (/^image/.test(file.type)) {
          // 创建一个reader
          const reader = new FileReader()
          // 将图片2将转成 base64 格式
          reader.readAsDataURL(file)
          // 读取成功后的回调
          reader.onloadend = async function () {
            const result = this.result
            const img = new Image()
            img.src = result
            // 判断图片是否大于500K,是就直接上传，反之压缩图片
            if (this.result.length <= 500 * 1024) {
              // 上传图片
              await self.postImg(this.result)
              resolve(this.result)
            } else {
              Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: '加载中'
              })
              img.onload = async function () {
                const data = self.compress(img, Orientation)
                // 上传图片
                await self.postImg(data)
                resolve(data)
              }
              img.onerror = function () {
                Toast.clear()
                resolve()
              }
            }
          }
        }
      })
    },
    // 压缩图片
    compress(img, Orientation) {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      // 瓦片canvas
      const tCanvas = document.createElement('canvas')
      const tctx = tCanvas.getContext('2d')
      // let initSize = img.src.length;
      let width = img.width
      let height = img.height
      // 如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      let ratio
      if ((ratio = (width * height) / 4000000) > 1 && !this.isHD) {
        // console.log("大于400万像素");
        ratio = Math.sqrt(ratio)
        width /= ratio
        height /= ratio
      } else {
        ratio = 1
      }
      canvas.width = width
      canvas.height = height
      //    铺底色
      ctx.fillStyle = '#fff'
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      // 如果图片像素大于100万则使用瓦片绘制
      let count
      if ((count = (width * height) / 1000000) > 1) {
        // console.log("超过100W像素");
        count = ~~(Math.sqrt(count) + 1) // 计算要分成多少块瓦片
        //      计算每块瓦片的宽和高
        const nw = ~~(width / count)
        const nh = ~~(height / count)
        tCanvas.width = nw
        tCanvas.height = nh
        for (let i = 0; i < count; i++) {
          for (let j = 0; j < count; j++) {
            tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh)
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh)
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height)
      }
      // 修复ios上传图片的时候 被旋转的问题
      // console.log('Orientation IOS旋转',Orientation);
      if (Orientation != '' && Orientation != 1) {
        switch (Orientation) {
          // case 6: //需要顺时针（向左）90度旋转
          //   this.rotateImg(img, "left", canvas);
          //   break;
          case 8: // 需要逆时针（向右）90度旋转
            this.rotateImg(img, 'right', canvas)
            break
          case 3: // 需要180度旋转
            this.rotateImg(img, 'right', canvas) // 转两次
            this.rotateImg(img, 'right', canvas)
            break
        }
      }
      // 进行最小压缩
      const quality = this.isHD ? 1 : 0.5
      const ndata = canvas.toDataURL('image/jpeg', quality)
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0
      // console.log(ndata);
      return ndata
    },
    // 旋转图片
    rotateImg(img, direction, canvas) {
      // 最小与最大旋转方向，图片旋转4次后回到原方向
      const min_step = 0
      const max_step = 3
      if (img == null) return
      // img的高度和宽度不能在img元素隐藏后获取，否则会出错
      const height = img.height
      const width = img.width
      let step = 2
      if (step == null) {
        step = min_step
      }
      if (direction == 'right') {
        step++
        // 旋转到原位置，即超过最大值
        step > max_step && (step = min_step)
      } else {
        step--
        step < min_step && (step = max_step)
      }
      // 旋转角度以弧度值为参数
      const degree = (step * 90 * Math.PI) / 180
      const ctx = canvas.getContext('2d')
      switch (step) {
        case 0:
          canvas.width = width
          canvas.height = height
          ctx.drawImage(img, 0, 0)
          break
        case 1:
          canvas.width = height
          canvas.height = width
          ctx.rotate(degree)
          ctx.drawImage(img, 0, -height)
          break
        case 2:
          canvas.width = width
          canvas.height = height
          ctx.rotate(degree)
          ctx.drawImage(img, -width, -height)
          break
        case 3:
          canvas.width = height
          canvas.height = width
          ctx.rotate(degree)
          ctx.drawImage(img, -width, 0)
          break
      }
    },
    // 将base64转换为文件
    dataURLtoFile(dataurl) {
      var arr = dataurl.split(',')
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], this.files.name, {
        type: this.files.type
      })
    },
    // 提交图片到后端
    postImg(base64) {
      // 添加不需要向后端发送请求的拦截props  用于iframe嵌入
      if (this.nofatch === true) {
        return
      }
      const file = this.dataURLtoFile(base64)
      // console.log('file2222: ', file.size / 1024)
      const formData = new window.FormData()
      formData.append('file', file)
      // console.log(file);
      // 提交图片 调用接口
      // Some code
      let name = file.name
      name = name.substring(name.lastIndexOf('.') + 1)
      formData.append('format', name)
      formData.append('module', 'collection')
      formData.append('scene', 'task')
      formData.append('terminalName', this.$store.state.userInfo.terminalName) // 打开后端添加水印
      imageUpload(formData)
        .then(async (res) => {
          if (res.data.success) {
            this.uploader[0].reUrl = res.data.data.fileUrl
            // this.uploader[0].content = res.data.data.absoluteFileUrl;//组件内默认content设置为undefined之后就取url所以不改content也可以
            this.uploader[0].url = res.data.data.absoluteFileUrl // 打开可立即展示水印后的图片 暂时不需要会造成内存压力大
            const newObj = JSON.parse(JSON.stringify(this.item))

            let info = null

            console.log('this.tips: ', this.tips)
            if (this.tips === '盒马POS照') {
              const res2 = await getIdentificationPa({
                imageUrl: res.data.data.fileUrl,
                projectName: this.$store.state.userInfo.projectName,
                projectCode: this.$store.state.userInfo.projectCode,
                tenCode: this.tenCode
              })
              if (res2.data.success) {
                info = res2.data.data
              } else {
                setTimeout(() => {
                  Dialog.alert({
                    title: '提示',
                    message: '照片未能完整识别，请按说明重新上传'
                  }).then(() => {
                    // on close
                    const index = this.uploader.findIndex((item) => item.reUrl === this.item.relativeUrl)
                    console.log('index: ', index)
                    if (index !== -1) {
                      this.uploader.splice(index, 1)
                    }
                    this.remove()
                  })
                }, 0)
              }
            }

            this.$emit('update:item', {
              ...newObj,
              // 20230206 移除itemImg字段全部使用 itemImgs
              // itemImg: res.data.data.fileUrl,
              absoluteUrl: res.data.data.absoluteFileUrl,
              relativeUrl: res.data.data.fileUrl,
              info
            })
            this.uploader[0].status = 'done'
            this.$emit('myDisabled', this.code, false)
            this.$emit('done', this.index)

            // setTimeout(() => {
            //   console.log('this.uploader', this.uploader)
            //   const { barCode, salePrice, thirtyDaysSale, yesterdaySale } = this.item.info || {}
            //   const { online: online1, offline: offline1, unit: unit1 } = thirtyDaysSale || {}
            //   const { online: online2, offline: offline2, unit: unit2 } = yesterdaySale || {}
            //   console.log('barCode: ', barCode)
            //   if (
            //     !barCode ||
            //     salePrice == null ||
            //     online1 == null ||
            //     offline1 == null ||
            //     online2 == null ||
            //     offline2 == null ||
            //     !unit1 ||
            //     !unit2
            //   ) {
            //     Dialog.alert({
            //       title: '提示',
            //       message: '照片未能完整识别，请按说明重新上传'
            //     }).then(() => {
            //       // on close
            //       const index = this.uploader.findIndex((item) => item.reUrl === this.item.relativeUrl)
            //       console.log('index: ', index)
            //       if (index !== -1) {
            //         this.uploader.splice(index, 1)
            //       }
            //       this.remove()
            //     })
            //   }
            // }, 0)
          } else {
            this.uploader[0].status = 'failed'
            Dialog.alert({
              title: '提示',
              message: res.data.errorMessage
            })
            this.uploader = []
          }
          this.$store.commit('changeloadingStatus', false)
        })
        .catch((err) => {
          console.log('上传失败 err: ', err)
          this.uploader[0].status = 'failed'
          this.$store.commit('changeloadingStatus', false)
          Dialog.alert({
            title: '提示',
            message: '图片上传失败请重新上传'
          })
          this.uploader = []
        })
    },
    // 点击删除
    remove() {
      const newObj = JSON.parse(JSON.stringify(this.item))
      console.log('点击删除', newObj)
      this.$emit('update:item', {
        ...newObj,
        // 20230206 移除itemImg字段全部使用 itemImgs
        // itemImg: '',
        absoluteUrl: '',
        relativeUrl: '',
        info: null
      })
      this.$emit('remove', this.index)
    },
    // 安全的 EXIF 时间获取
    getPhotoDateTime(file) {
      return new Promise((resolve, reject) => {
        Exif.getData(file, function() {
          try {
            // 获取多个时间字段进行验证
            const dateTimeOriginal = Exif.getTag(this, 'DateTimeOriginal'); // 原始拍摄时间
            const dateTime = Exif.getTag(this, 'DateTime'); // 修改时间
            const dateTimeDigitized = Exif.getTag(this, 'DateTimeDigitized'); // 数字化时间
            // 检查是否存在至少一个有效的时间信息
            const validTime = dateTimeOriginal || dateTime || dateTimeDigitized;
            if (!validTime) {
              // 未找到时间信息
              reject(new Error('[ERROR-UP-00001]请重新拍照上传' + ',dateTimeOriginal=' + dateTimeOriginal + ',dateTime=' + dateTime + ',dateTimeDigitized=' + dateTimeDigitized));
              return;
            }
            // 解析时间字符串
            const timeStr = validTime.replace(/[:]/g, '-').replace(' ', 'T');
            const match = validTime.trim().match(/^(\d{4}):(\d{2}):(\d{2})\s+(\d{2}):(\d{2}):(\d{2})$/);
            if (!match) {
              //'时间格式无效'
              reject(new Error('[ERROR-UP-00002]请重新拍照上传' + ',dateTimeOriginal=' + dateTimeOriginal + ',dateTime=' + dateTime + ',dateTimeDigitized=' + dateTimeDigitized + ',timeStr=' + timeStr));
              return;
            }

            const [, year, month, day, hour, minute, second] = match;
            // 注意：month 需 -1，因为 Date 月份从 0 开始
            const date = new Date(
              parseInt(year, 10),
              parseInt(month, 10) - 1,
              parseInt(day, 10),
              parseInt(hour, 10),
              parseInt(minute, 10),
              parseInt(second, 10)
            );

            const photoTime = isNaN(date.getTime()) ? null : date;
            if (!photoTime) {
              //'时间格式无效'
              reject(new Error('[ERROR-UP-00003]请重新拍照上传'));
              return;
            }
            resolve(photoTime);
          } catch (error) {
            reject(new Error('[ERROR-UP-00004]读取EXIF信息失败：' + error.message));
          }
        });
      });
    },
    // 获取设备信息
    async getUserAgent(msg) {
      // //调用上传设备信息 ip接口 用户信息
      var output = new UA(navigator.userAgent) //UA获取到的对象
      var sss = navigator.userAgent.split(';')
      //判断UA里边有没有Build信息，通过这个拿到安卓的具体机型
      var i = -1
      sss.forEach((element, index) => {
        if (element.includes('Build/')) {
          i = index
        }
      })
      let newMobile //如果是安卓手机返回安卓的型号
      if (i > -1) {
        newMobile = sss[i].substring(0, sss[i].indexOf('Build/'))
      }
      // console.log(output.device.identified ? output.device.model : newMobile)//设备型号
      // console.log(output.browser.name + ' ' + output.browser.version.original)//浏览器版本
      // console.log(output.os.name + ' ' + output.os.version.original)//系统版本
      let ip = ''
      try {
        ip = returnCitySN.cip
      } catch {}
      await addHardwareLog({
        funTitle: this.$store.state.taskCode + this.$store.state.taskTitle + '-UploadField',
        userAgents: navigator.userAgent,
        resolvingPower: `${screen.width}x${window.screen.height}`,
        ip: ip,
        userCode: this.$store.state.openOrScheduleId.openId, //传的字段是userCode实际传的是openId
        browser: output.browser.name + ' ' + output.browser.version.original,
        os: output.os.name + ' ' + output.os.version.original,
        device: output.device.identified ? output.device.model : newMobile,
        locErr: msg
      })
    }
  },
  created() {
    // 单图组件反显图片
    // 20230206 移除itemImg字段全部使用 itemImgs
    // if (this.item.itemImg !== null && this.item.itemImg !== undefined) {
    //   this.uploader = [{ url: this.item.itemImg }]
    // }
    // 多图组件反显
    if (this.item.absoluteUrl && this.item.relativeUrl) {
      if (this.nofatch === true) {
        // 兼容不发请求的时候的反显
        this.uploader = [{ content: this.item.absoluteUrl }]
      } else {
        this.uploader = [{ url: this.item.absoluteUrl }]
      }
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .van-field {
  padding: 0px 23px;
}
.allBox {
  position: relative;
  width: 100%;
  .example {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #333333;
    .arrow {
      position: relative;
      top: 2px;
      margin-left: 13px;
    }
  }
}
</style>
